import React from "react";
import { Link, useLocation } from "react-router-dom";

function BackgroundTitle({ title }) {
  const { pathname } = useLocation();

  return (
    <>
      <div className='bg-fixed bg-background bg-no-repeat bg-cover relative h-screen sm:h-[85vh] w-full'>
        <div className='absolute inset-0 customBackground flex justify-center items-center'>
          <div className='w-[90%] md:w-2/3 lg:w-1/3 leading-loose text-white'>
            <div className='text-center uppercase z-10'>
              <Link
                to='/'
                className='text-sm pb-1 border-b-2 border-sky-300 inline mr-3 cursor-pointer'
              >
                Home
              </Link>
              <Link
                to={pathname}
                className='text-sm pb-1 border-b-2 border-sky-300 inline cursor-pointer'
              >
                {pathname.split("/")[1]}
              </Link>
              <h1 className='text-3xl md:text-5xl mt-5 font-medium'>{title}</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BackgroundTitle;
